<template>
  <div class="policy-page">
    <div class="page-header">利用規約に同意</div>

    <div class="policy-content h-250">
        <iframe class="w100 h100" src="https://www.pocketmeeting.jp/rules.html" frameborder="0"></iframe>
    </div>

    <a @click="acceptPolicy" href="javascript:void(0)" class="accept-policy-btn button default">利用規約に同意する</a>

  </div>
</template>

<script>
import AuthApi from '@/api/auth'
import {apiErrorDialog} from '@/helpers'
export default {
  methods: {
    async acceptPolicy () {
      const loading = this.$loading.show({opacity: 1})
      try {
        await AuthApi.applyPolicy()
          .catch((error) => {
            apiErrorDialog(this, error)
          })
        localStorage.setItem('policy_applied', 'true')
        setTimeout(() => { window.location.reload() }, 1000)
      } catch (e) {
        loading.hide()
      }
    }
  }
}
</script>

<style lang="scss">
  .policy-page {
    background: #dfedf5;
    height: calc(100vh - 48px);
    .page-header {
      padding: 0;
      text-align: center;
      line-height: 50px;
      height: 50px;
      color: #fff;
      background: #1199c9;
      font-size: 18px;
      font-weight: 700;
    }
    .policy-content {
      background: #fff;
      width: 500px;
      margin: 50px auto 0 auto;
      padding: 20px;
    }
    .accept-policy-btn {
      width: 500px;
      margin: 0 auto;
      display: block;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      font-weight: 700;
      margin-top: 60px;
    }
  }
  @media (max-width: 600px) {
    .policy-page {
      .policy-content {
        width: 95vw;
      }
      .accept-policy-btn {
        width: 95vw;
      }
    }
  }
  @media (max-height: 400px) {
    .policy-page {
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Policy.vue